export interface Country {
  iso2: string;
  name: string;
  dialCode: string;
}

export const COUNTRIES: readonly Country[] = [
  { iso2: 'tw', name: 'Taiwan', dialCode: '886' },
  { iso2: 'hk', name: 'Hong Kong', dialCode: '852' },
  { iso2: 'mo', name: 'Macau', dialCode: '853' },
  { iso2: 'cn', name: 'China', dialCode: '86' },
  { iso2: 'jp', name: 'Japan', dialCode: '81' },
  { iso2: 'kr', name: 'South Korea', dialCode: '82' },
  { iso2: 'sg', name: 'Singapore', dialCode: '65' },
  { iso2: 'my', name: 'Malaysia', dialCode: '60' },
  { iso2: 'th', name: 'Thailand', dialCode: '66' },
  { iso2: 'vn', name: 'Vietnam', dialCode: '84' },
  { iso2: 'ph', name: 'Philippines', dialCode: '63' },
  { iso2: 'id', name: 'Indonesia', dialCode: '62' },
  { iso2: 'in', name: 'India', dialCode: '91' },
  { iso2: 'us', name: 'United States', dialCode: '1' },
  { iso2: 'ca', name: 'Canada', dialCode: '1' },
  { iso2: 'mx', name: 'Mexico', dialCode: '52' },
  { iso2: 'br', name: 'Brazil', dialCode: '55' },
  { iso2: 'ar', name: 'Argentina', dialCode: '54' },
  { iso2: 'gb', name: 'United Kingdom', dialCode: '44' },
  { iso2: 'ie', name: 'Ireland', dialCode: '353' },
  { iso2: 'de', name: 'Germany', dialCode: '49' },
  { iso2: 'fr', name: 'France', dialCode: '33' },
  { iso2: 'es', name: 'Spain', dialCode: '34' },
  { iso2: 'it', name: 'Italy', dialCode: '39' },
  { iso2: 'nl', name: 'Netherlands', dialCode: '31' },
  { iso2: 'be', name: 'Belgium', dialCode: '32' },
  { iso2: 'ch', name: 'Switzerland', dialCode: '41' },
  { iso2: 'at', name: 'Austria', dialCode: '43' },
  { iso2: 'se', name: 'Sweden', dialCode: '46' },
  { iso2: 'no', name: 'Norway', dialCode: '47' },
  { iso2: 'dk', name: 'Denmark', dialCode: '45' },
  { iso2: 'fi', name: 'Finland', dialCode: '358' },
  { iso2: 'pl', name: 'Poland', dialCode: '48' },
  { iso2: 'cz', name: 'Czechia', dialCode: '420' },
  { iso2: 'pt', name: 'Portugal', dialCode: '351' },
  { iso2: 'gr', name: 'Greece', dialCode: '30' },
  { iso2: 'tr', name: 'Turkey', dialCode: '90' },
  { iso2: 'ru', name: 'Russia', dialCode: '7' },
  { iso2: 'ua', name: 'Ukraine', dialCode: '380' },
  { iso2: 'au', name: 'Australia', dialCode: '61' },
  { iso2: 'nz', name: 'New Zealand', dialCode: '64' },
  { iso2: 'il', name: 'Israel', dialCode: '972' },
  { iso2: 'ae', name: 'United Arab Emirates', dialCode: '971' },
  { iso2: 'sa', name: 'Saudi Arabia', dialCode: '966' },
  { iso2: 'za', name: 'South Africa', dialCode: '27' },
  { iso2: 'eg', name: 'Egypt', dialCode: '20' },
];

const BY_ISO2 = new Map(COUNTRIES.map((c) => [c.iso2, c]));

export function getCountry(iso2: string): Country | undefined {
  return BY_ISO2.get(iso2.toLowerCase());
}

/**
 * Convert iso2 code (e.g. "tw") to Twemoji flag hex codepoints (e.g. "1f1f9-1f1fc").
 * Each ASCII letter is offset to its Regional Indicator Symbol code point.
 */
export function iso2ToTwemojiCode(iso2: string): string {
  const upper = iso2.toUpperCase();
  const a = upper.charCodeAt(0) - 0x41 + 0x1f1e6;
  const b = upper.charCodeAt(1) - 0x41 + 0x1f1e6;
  return `${a.toString(16)}-${b.toString(16)}`;
}

export function flagUrl(iso2: string): string {
  return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${iso2ToTwemojiCode(iso2)}.svg`;
}
